import React from "react";
import Navbar from "../components/Navbar";
import AppSidebar from "../components/MySidebar";
import CustomSidebarButton from "../components/CustomSidebarButton";
import { useLang } from "../context/TranslationProvider";
import MY_CONFIG from "@/constants";
import MyNavbar from "@/MY_COMPONENTS/MY_NAVBARS/MyNavbar";


export default function MainLayout({ children }: { children: React.ReactNode }) {
  const { t } = useLang();

  return (
    <div className="h-screen flex flex-col justify-between bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 w-full overflow-x-hidden ">
      {/* NAVBAR MUST BE ABOVE FLEX ROW */}
      <div className="w-screen h-[7%]">
          <MyNavbar />
      </div>


      <div className="h-full flex w-full overflow-hidden ">
        
        {/* SIDEBAR */}
        <aside
          className="
            hidden lg:block
            sticky top-20
            bg-white dark:bg-gray-800
            shadow-md border-r border-gray-200 dark:border-gray-700
            p-4
            w-56
            h-screen
            flex-shrink-0
          "
        >
          <AppSidebar />
        </aside>

        {/* MAIN CONTENT — ADD min-w-0 FIXES OVERFLOW */}
        <div className="flex-1 min-w-0 flex flex-col">

          {/* MOBILE SIDEBAR */}
          <div className="lg:hidden px-4 py-2">
            <CustomSidebarButton
              sidebarHeader={
                <div className="flex items-center space-x-3">
                  <img
                    src={MY_CONFIG.ICON_URL}
                    alt="Logo"
                    className="w-10 h-10 rounded-full"
                  />
                  <span className=" text-[12px] uppercase">
                    {t("site_official_name")}
                  </span>
                </div>
              }
              sidebarContent={<AppSidebar />}
              padding="px-4 py-2"
              bgColor="bg-blue-600"
              hoverColor="hover:bg-blue-700"
              textColor="text-white"
              rounded="lg"
            />
          </div>

          <main className="pt-0 px-4 w-full overflow-x-hidden">
            {children}
          </main>
        </div>
      </div>
    </div>
  );
}